const state = {
  selectedMapElement: "",
  defaultMapZoom: 5,
  baseLayer: {
    url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  },
  projections : {
    // WGS84
    "4326": {
      proj4 : [
        'EPSG:4326','+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'
      ]
    },
    // France -- RGF93 / Lambert-93
    "2154": {
      proj4 : [
        'EPSG:2154','+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
      ],
      wgs84Center : [46.227638, 2.213749],
      zoom : 5
    },
    // Guadeloupe et Martinique -- RRAF 1991 / UTM zone 20N
    "4559": {
      proj4 : [
        'EPSG:4559','+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
      ],
      wgs84Center : [15.512337,  -61.245300],
      zoom : 7
    },
    // Guyane -- RGFG95 / UTM zone 22N
    "2972": {
      proj4 : [
        'EPSG:2972','+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
      ],
      wgs84Center : [3.978612, -53.155215],
      zoom : 6
    },
    // Réunion -- RGR92 / UTM zone 40S
    "2975": {
      proj4 : [
        'EPSG:2975','+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
      ],
      wgs84Center : [-21.132550, 55.530010],
      zoom : 9
    },
    // Mayotte -- RGM04 / UTM zone 38S
    "4471": {
      proj4 : [
        'EPSG:4471','+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
      ],
      wgs84Center : [-12.822287, 45.154170],
      zoom : 9
    },
    // Saint Pierre et Miquelon -- Saint Pierre et Miquelon 1950 / UTM zone 21N
    "2987": {
      proj4 : [
        'EPSG:2987','+proj=utm +zone=21 +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +units=m +no_defs'
      ],
      wgs84Center : [46.938021, -56.287269],
      zoom : 9
    },
  }
};

const mutations = {
  SET_SELECTED_MAP_ELEMENT(state, selectedMapElement) {
    state.selectedMapElement = selectedMapElement;
  },
  REMOVE_SELECTED_MAP_ELEMENT(state) {
    state.selectedMapElement = "";
  }
};

const actions = {
  saveSelectedMapElement({ commit }, selectedMapElement) {
    commit("SET_SELECTED_MAP_ELEMENT", selectedMapElement);
  },
  clearSelectedMapElement({ commit }) {
    commit("REMOVE_SELECTED_MAP_ELEMENT");
  }
};

const getters = {
  selectedMapElement(state) {
    return state.selectedMapElement;
  },
  defaultMapZoom(state) {
    return state.defaultMapZoom;
  },
  baseLayer(state) {
    return state.baseLayer;
  },
  projections(state) {
    return state.projections;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
